// PayDirt API — Market endpoints

import { apiFetch } from './client';

export const fetchSourceMarkets = () => apiFetch('/api/markets/sources');
export const fetchAuthorMarkets = () => apiFetch('/api/markets/authors');
